const ERRORCODE = {
	NOTFOUND: 'NOTFOUND',
	PASSWORD_RESET_REQUIRED: 'PASSWORD_RESET_REQUIRED',
	UNAUTHORIZED_DEACTIVATED: 'UNAUTHORIZED_DEACTIVATED',
	UNAUTHORIZED_DEFAULT: 'UNAUTHORIZED_DEFAULT',
	UNAUTHORIZED_RATE_LIMITED: 'UNAUTHORIZED_RATE_LIMITED',
};

const PRICING_PAGE = '/pricing';

const TWO_YEARS_IN_S = 63_072_000;

module.exports = {
	ERRORCODE,
	PRICING_PAGE,
	TWO_YEARS_IN_S,
};
